import { render, staticRenderFns } from "./LoadingMoreIndicator.vue?vue&type=template&id=4960cdf3&scoped=true&"
import script from "./LoadingMoreIndicator.vue?vue&type=script&lang=js&"
export * from "./LoadingMoreIndicator.vue?vue&type=script&lang=js&"
import style0 from "./LoadingMoreIndicator.vue?vue&type=style&index=0&id=4960cdf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960cdf3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
